import React from 'react';
import * as Style from './IconMultipleArrows.style';

const IconMultipleArrows = ({
  color = '#4480c5',
  testId = 'icon-multiple-arrows-info',
  height = '24',
  width = '114',
}) => (
  <Style.Wrapper data-testid={testId}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 113.77 24">
      <g id="arrow_forward_ios_black_24dp" transform="translate(83.77)">
        <g id="Grupo_40091" data-name="Grupo 40091">
          <path id="Caminho_247739" data-name="Caminho 247739" d="M0,0H24V24H0Z" fill="none" />
        </g>
        <g id="Grupo_40092" data-name="Grupo 40092">
          <path id="Caminho_247740" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40093" data-name="Grupo 40093" transform="translate(6)">
          <path id="Caminho_247740-2" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40094" data-name="Grupo 40094" transform="translate(12)">
          <path id="Caminho_247740-3" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40095" data-name="Grupo 40095" transform="translate(-18)" opacity="0.7">
          <path id="Caminho_247740-4" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40096" data-name="Grupo 40096" transform="translate(-12)" opacity="0.7">
          <path id="Caminho_247740-5" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40097" data-name="Grupo 40097" transform="translate(-6)" opacity="0.7">
          <path id="Caminho_247740-6" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40098" data-name="Grupo 40098" transform="translate(-36)" opacity="0.55">
          <path id="Caminho_247740-7" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40099" data-name="Grupo 40099" transform="translate(-30)" opacity="0.55">
          <path id="Caminho_247740-8" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40100" data-name="Grupo 40100" transform="translate(-24)" opacity="0.55">
          <path id="Caminho_247740-9" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40101" data-name="Grupo 40101" transform="translate(-54)" opacity="0.4">
          <path id="Caminho_247740-10" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40102" data-name="Grupo 40102" transform="translate(-48)" opacity="0.4">
          <path id="Caminho_247740-11" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40103" data-name="Grupo 40103" transform="translate(-42)" opacity="0.4">
          <path id="Caminho_247740-12" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40104" data-name="Grupo 40104" transform="translate(-72)" opacity="0.25">
          <path id="Caminho_247740-13" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40105" data-name="Grupo 40105" transform="translate(-66)" opacity="0.25">
          <path id="Caminho_247740-14" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40106" data-name="Grupo 40106" transform="translate(-60)" opacity="0.25">
          <path id="Caminho_247740-15" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40107" data-name="Grupo 40107" transform="translate(-90)" opacity="0.1">
          <path id="Caminho_247740-16" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40108" data-name="Grupo 40108" transform="translate(-84)" opacity="0.1">
          <path id="Caminho_247740-17" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
        <g id="Grupo_40109" data-name="Grupo 40109" transform="translate(-78)" opacity="0.1">
          <path id="Caminho_247740-18" data-name="Caminho 247740" d="M6.23,20.23,8,22,18,12,8,2,6.23,3.77,14.46,12Z" fill={color} />
        </g>
      </g>
    </svg>
  </Style.Wrapper>
);


export default IconMultipleArrows;
